import { render } from "./HeroiconsSolidCloudUpload.vue?vue&type=template&id=be34d926"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCloudUpload.vue"]])

export default __exports__